let PackagesItem = [
    {
        track: 'Junior',
        trackJunior: true,
        trackTitle: "Junior Track",
        trackSubtitle: true,
        trackPrice: "0",
        runningString: true,
        trackButton: "Register",
        // trackLink: 'https://geekle.us/ticketfree/1690872950522x487494572703481860',
        juniorTicket1Name: "Free Ticket",
        juniorTicket1Price: "0.00",
        juniorTicket1Link: "https://geekle.us/ticketfree/1690872950522x487494572703481860",
        juniorTicket2Name: "+ Certificate",
        juniorTicket2Price: "9.99",
        juniorTicket2Link: "https://geekle.us/ticket/1699050341312x186380635744501760",
        juniorTicket3Name: "+ Certificate & Recordings",
        juniorTicket3Price: "15.99",
        juniorTicket3Link: "https://geekle.us/ticket/1699051788398x406571368159641600",
    },
    {
        track: 'Full Access',
        trackFull: true,
        trackTitle: "FULL ACCESS 🔥",
        trackSubtitle: "ticket",
        runningString: true,
        trackPrice: "49",
        earlyBird: "early birds price",
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Junior and Senior Blocks Access',
        trackLink: 'https://geekle.us/ticket/1684329319509x876033696921026600',
    },
    {
        track: 'Premium',
        newPremium: true,
        trackTitle: "GEEKLE PREMIUM",
        trackSubtitle: "MEMBERSHIP",
        trackPriceApperance: 2,
        trackPrice: "399",
        trackText: true,
        trackText1: "One Year Premium Membership",
        trackDesc: "1",
        trackButton: "BUY",
        trackLink: 'https://geekle.us/ticket/1696847842733x949907249339039700',
        inverseColors: true,
    },
    // {
    //     trackTitle: "TEAM-5",
    //     trackSubtitle: "YEAR GROUP PACKAGE",
    //     trackPriceApperance: 3,
    //     runningString: true,
    //     trackPrice: "999",
    //     trackText: true,
    //     trackText1: "One Year Pass for 5 team members",
    //     trackDesc: "1",
    //     trackButton: "BUY",
    //     trackLink: 'https://geekle.us/ticket/1694109810106x843614570263085000',
    // },
    // {
    //     trackMode: 'Halloween',
    //     trackTitle: "FRANKENSTEIN'S HALLOWEEN 3+1 PACK",
    //     trackSubtitle: true,
    //     trackPrice: "179",
    //     trackText: true,
    //     trackButton: "GRAB SPOOKY DEAL",
    //     trackLink: 'https://geekle.us/ticket/1698044453451x220433225697198100',
    // },
    {
        track: 'Unlimited',
        trackTitle: "UNLIMITED",
        trackSubtitle: "YEAR ENTERPRISE PACKAGE",
        trackPriceApperance: 4,
        runningString: true,
        trackPrice: "Ask Our Manager",
        trackText: true,
        trackText1: "One Year Pass for up to 100 members",
        trackDesc: "1",
        trackButton: "Get Offer",
        trackLink: 'enterprise',
        validDate: '9.06',
    },
];

export default PackagesItem;
